import useIsMobile from "../hooks/useIsMobile";
import { cloneElement, ReactElement } from "react";

export default ({
  visible,
  children,
}: {
  visible: boolean;
  children: ReactElement;
}) => {
  const isMobile = useIsMobile();

  if (!isMobile) {
    return children;
  }

  // On mobile: hide with display:none when not visible (preserves state instead of unmounting)
  return cloneElement(children, {
    sx: { ...children.props.sx, display: visible ? undefined : "none" },
  });
};
